import React from 'react'
import * as R from 'ramda'
import { Dropdown } from 'semantic-ui-react'

export const VariableControls = ({ variables, onSelect }) => {
  if (R.isEmpty(variables) || !variables) {
    return null
  }

  return (
    <Dropdown icon="fas fa-brackets-curly" className="richeditor-styleButton">
      <Dropdown.Menu>
        {variables.map((item) => (
          <Dropdown.Item key={item.name} text={item.name} onClick={() => onSelect(item.value)} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/RichEditor/VariableControls.js